import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useCreateSignatureUser() {
  const token = useAccessToken()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      fotoPessoa,
      fotoDoc,
      local,
      maquina
    }: {
      fotoPessoa: File | null
      fotoDoc: File | null
      local: string | null
      maquina: string | null
    }) => {
      if (!token) throw new Error('Token está ausente')

      if (!fotoPessoa || !fotoDoc) {
        throw new Error('Fotos são obrigatórias.')
      }

      const formData = new FormData()
      formData.append('fotoPessoa', fotoPessoa)
      formData.append('fotoDoc', fotoDoc)
      formData.append('local', local || '')
      formData.append('maquina', maquina || '')

      const response = await api.post('/signatures/userID', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })

      if (response.data) {
        queryClient.refetchQueries({
          queryKey: ['signature']
        })
        return response.data
      } else {
        throw new Error('Erro ao criar assinatura')
      }
    }
  })
}
